export default function () {
  const dialogEl = document.querySelector("#geolocation-popup");

  if(!dialogEl) return;

  const closeBtn = dialogEl.querySelector("#geolocation-popup-close-btn");

  dialogEl.showModal();
  document.querySelector('body').classList.add('overflow-hidden');

  closeBtn.addEventListener("click", () => {
    dialogEl.close();
  });

  dialogEl.addEventListener('close', () => {
    document.querySelector('body').classList.remove('overflow-hidden');
  });
}
